import { Body } from 'component-library/components/typography/Body';
import { Heading } from 'component-library/components/typography/Heading';
import { Screen, ShowOn } from 'component-library/components/wrappers/ShowOn';
import { device } from 'component-library/styles/device';
import React, { FC } from 'react';
import styled from 'styled-components';

import { ValuePropGridSectionProps } from '.';
import { GridSectionWrapper } from './GridSectionWrapper';
import { ValuePropItem } from './ValuePropItem';

const StyledValuePropItem = styled(ValuePropItem)`
  ${`@media ${device.md}`} {
    margin-bottom: 0;
    flex-basis: 46%;
  }
`;

const StyledGridSectionWrapper = styled(GridSectionWrapper)`
  display: flex;
  flex-wrap: wrap;
  gap: 58px;
`;

const Wrapper = styled(ShowOn)`
  padding: 64px 20px;
`;

const Image = styled.div`
  max-width: 400px;
  margin: auto;
`;

export const ValuePropGridSectionSmall: FC<ValuePropGridSectionProps> = ({
  heading,
  body,
  valueProps,
  Button,
  image,
}) => (
  <Wrapper screens={[Screen.Sm, Screen.Md]}>
    <Image>{image}</Image>
    <Heading variant={4} marginBottom={16} marginTop={32}>
      {heading}
    </Heading>
    <Body variant={3} marginBottom={32}>
      {body}
    </Body>
    <Button marginBottom={32} />
    <StyledGridSectionWrapper padding="40px 48px">
      {valueProps.map((valueProp, idx) => (
        <StyledValuePropItem {...valueProp} key={idx} />
      ))}
    </StyledGridSectionWrapper>
  </Wrapper>
);
